module.exports = __webpack_public_path__ + "static/img/5.5c8dbe8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/eng/5.png
// module id = topx
// module chunks = 0